<div class="lyltc">
  @if (isComingSoon && !lockview) {
    <loyaltic-coming-soon></loyaltic-coming-soon>
  }
  @if (!isComingSoon && !lockview) {
    <loyaltic-layout ></loyaltic-layout>
  }
  <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '0', fullScreenBackdrop:true }"></ngx-loading>
</div>
